import { create } from "zustand";
import { Button, Card, Space, Modal, notification, Popover } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import DataListStore from "store/DataListStore";
import ListViewV2 from "../DataListV2";
import { useEffect, useRef, useState } from "react";
import {
  ProForm,
  ProFormDigit,
  ProFormSelect,
  ProFormText,
} from "@ant-design/pro-components";
import { getRequest } from "services/EndPointApiService";
import { AddBarangKirim } from "services/datalist/datalist-api";
import ApplicationStore from "store/ApplicationStore";
import { Container } from "reactstrap";
import { postRequest } from "services/EndPointApiService";

const kirimDepokStore = create(DataListStore);
const kirimDepokHistoryStore = create(DataListStore);

async function requestNamaTokoBeli() {
  let data = await getRequest("DataList/GetNamaTokoBeli");
  return data.map((d) => ({
    value: d.NamaToko,
    label: d.NamaToko,
  }));
}

async function requestProductShopee() {
  let data = await getRequest("DataList/GetProductShopee");
  return data.map((d) => ({
    value: d.KodeBarang,
    label: d.KodeBarang,
  }));
}

async function requestProductVariation() {
  let data = await getRequest("DataList/GetProductVariation");
  return data.map((d) => ({
    value: d.JenisBarang,
    label: d.JenisBarang,
  }));
}

async function requestKirimDepokSummary() {
  let data = await getRequest("DataList/GetKirimDepokSummary");
  if (data.length > 0) {
    return data[0];
  }
  return { TotalBarang: 0, HargaTotal: 0 };
}

async function requestDeleteTablePengiriman() {
  await postRequest("DataList/ClearTablePengiriman");
}

function ProsesKirimDepok(props) {
  const formRef = useRef();

  const formRefToko = useRef();

  const [sending, setSending] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [reloader, setReloader] = useState(false);

  const [isModalTambahTokoOpen, setIsModalTambahTokoOpen] = useState(false);
  const [sendingToko, setSendingToko] = useState(false);

  const [summary, setSummary] = useState({ TotalBarang: 0, HargaTotal: 0 });

  const userAuth = ApplicationStore((state) => state.userAuth);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const onModalOK = () => {
    formRef.current.submit();
  };

  useEffect(() => {
    requestKirimDepokSummary().then((res) => {
      setSummary(res);
    });
  }, [reloader]);

  return (
    <Card
      title={
        <strong>
          <h1>Barang Siap Kirim Depok</h1>
        </strong>
      }
    >
      <Button type="primary" onClick={openModal}>
        <Space>
          <PlusOutlined /> Tambahkan Barang
        </Space>
      </Button>

      <br />
      <br />
      <p>
        Total Barang :{" "}
        <b>{summary.TotalBarang?.toLocaleString("id") ?? 0} Pcs</b>
      </p>
      <p>
        Total Harga :{" "}
        <b> Rp. {summary.HargaTotal?.toLocaleString("id") ?? 0}</b>
      </p>

      <Modal
        title="Tambahkan Barang"
        open={isModalOpen}
        onOk={onModalOK}
        onCancel={closeModal}
        okButtonProps={{
          disabled: sending,
          title: sending ? "Menyimpan..." : "Simpan",
        }}
      >
        <ProForm
          formRef={formRef}
          submitter={false}
          onFinish={async (val) => {
            setSending(true);
            try {
              await AddBarangKirim(val).then(() => {
                notification.success({
                  message: "Success",
                  description:
                    "Berhasil menambahkan barang ke daftar kirim depok",
                });
              });

              formRef.current.resetFields();
              closeModal();
            } catch (e) {
              console.log(e);
            } finally {
              setSending(false);
            }
            setReloader(!reloader);
          }}
        >
          <ProFormSelect
            showSearch
            name={"kode"}
            label={"Kode Barang (Sesuai Pesanan)"}
            request={requestProductShopee}
            placeholder={"Silahkan cek kodebarang yang tersedia disini."}
          />
          <ProFormText
            name={"kode"}
            label="Kode Barang (Input Manual)"
            rules={[{ required: true }]}
          />
          <ProFormSelect
            name={"jenis"}
            label={"Jenis/ Bahan Dasar Barang"}
            rules={[{ required: true }]}
            request={requestProductVariation}
          />
          <ProFormDigit
            name={"jumlah"}
            label="Jumlah Barang"
            rules={[{ required: true }]}
          />
          <ProFormDigit
            name={"harga"}
            label="Harga Barang Satuan (Rupiah)"
            rules={[{ required: true }]}
          />
          <ProFormDigit
            name={"beli"}
            label="Harga Beli Satuan"
            rules={[{ required: false }]}
            step={0.01}
            precision={2}
          />
          <ProFormSelect
            showSearch
            name={"toko"}
            label="Nama Toko Beli"
            rules={[{ required: false }]}
            request={requestNamaTokoBeli}
          />
        </ProForm>

        <label style={{ color: "darkgreen", marginTop: "10px" }}>
          *Klik tombol dibawah untuk menambahkan nama toko baru.
        </label>
        <Button
          type="primary"
          onClick={() => {
            setIsModalTambahTokoOpen(true);
          }}
        >
          Tambah Nama Toko
        </Button>
      </Modal>

      <Modal
        title="Tambahkan Nama Toko Baru"
        open={isModalTambahTokoOpen}
        onOk={() => {
          formRefToko.current.submit();
        }}
        onCancel={() => {
          setIsModalTambahTokoOpen(false);
        }}
        okButtonProps={{
          disabled: sendingToko,
        }}
      >
        <ProForm
          formRef={formRefToko}
          submitter={false}
          onFinish={async (val) => {
            setSendingToko(true);
            try {
              await postRequest("DataList/AddNamaTokoBeli", val);

              notification.success({
                message: "Success",
                description: "Berhasil menambahkan nama toko baru",
              });

              formRefToko.current.resetFields();
              setIsModalTambahTokoOpen(false);
            } catch (e) {
              console.log(e);
            } finally {
              setSendingToko(false);
            }
            setReloader(!reloader);
          }}
        >
          <ProFormText
            name={"nama"}
            label="Nama Toko"
            rules={[{ required: true }]}
          />
        </ProForm>
      </Modal>

      {userAuth.superAdmin && (
        <Popover
          placement="right"
          content={
            <Container>
              <Space>
                <Button
                  type="primary"
                  danger
                  onClick={async () => {
                    await requestDeleteTablePengiriman();
                    notification.success({
                      message: "Clear Table",
                      description: "Successfully Clear Table",
                    });
                    setReloader(!reloader);
                  }}
                >
                  Process Clear
                </Button>
                <Button>Cancel</Button>
              </Space>
            </Container>
          }
          title="Delete Confirmation"
          trigger={"click"}
        >
          <Button danger>
            <Space>
              <DeleteOutlined /> Clear Table Pengiriman
            </Space>
          </Button>
        </Popover>
      )}
      <ListViewV2
        viewId="kirimdepok"
        store={kirimDepokStore}
        hideTitle={true}
        reloader={reloader}
      />

      <ListViewV2
        viewId="kirimdepokhistory"
        store={kirimDepokHistoryStore}
        reloader={reloader}
      />
    </Card>
  );
}

export default ProsesKirimDepok;
